<template lang="pug">
	.ssml-insertion-splitter
		Popup(v-if="visible", :popupVisible="innerVisible", :width="740", :height="480", :title="$tCaption('Split SSML')", @hiding="$emit('hiding')")
			.flex-col.space.ssml-insertion-splitter
				span {{$tCaption('Please mark the word, that would be a separator.')}}
				.flex-row.wrap
					.word(v-for="(word, idx) in splittedTextArray", @click="() => selectedIdx === idx ? selectedIdx = null : selectedIdx = idx", :class="{ 'selected': selectedIdx === idx }")
						.text {{word}}
			template(slot="actions-right")
				DxButton(text="Split", type="default", @click="() => doSplitSsml()", :disabled="selectedIdx === null")
				DxButton(text="Cancel", @click="() => setVisible(false)")
</template>

<script>
	import $ from 'jquery';
	import ssmlHelper from './ssml-helper';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'insertion.SSMLSplitter',
		name: 'ssml-insertion-splitter',
		props: ['ssml', 'visible'],
		components: { Popup, DxButton },
		data() {
			return {
				innerVisible: false,
				splitPosition: 0,
				innerSSML: this.ssml || '',
				joditConfig: {
					toolbar: false
				},
				selectedIdx: null
			};
		},
		computed: {
			formattedSsml() {
				return `${this.ssml}`
					.replace(new RegExp('<', 'g'), ' <')
					.replace(new RegExp('>', 'g'), '> ');
			},
			ssmlPlainText() {
				return $('<div>').append(this.formattedSsml).text() || '';
			},
			splittedTextArray() {
				return this.ssmlPlainText.split(' ').filter(f => `${f}`.trim());
			}
		},
		watch: {
			visible(v) {
				this.setVisible(v);
			},
			ssml(v) {
				this.innerSSML = this.ssml || '';
			}
		},
		mounted() {
			if (__DEBUG__)
				window.ssmlSplitter = this;
			this.setVisible(this.visible);
		},
		destroyed() {
		},
		methods: {
			setVisible(v) {
				this.innerVisible = false;
				if (v) {
					setImmediate(() => {
						if (this._isDestroyed) return;
						this.innerVisible = true;
					});
				}
			},
			doSplitSsml() {
				var word = this.splittedTextArray[this.selectedIdx];
				var wordRepeats = this.splittedTextArray.filter((f, i) => i < this.selectedIdx && f === word).length;
				var splittedSSML = `${this.formattedSsml}`.split(` ${word} `);
				var leftPart = splittedSSML.slice(0, wordRepeats + 1).join(` ${word} `) + ` ${word} `;
				var rightPart = splittedSSML.slice(wordRepeats + 1, splittedSSML.length).join(` ${word} `);

				//if splitting adthos-params, content of param should not be splitted
				var adthosTags = ['adthos:wbs', 'adthos:xls', 'adthos:audio', 'adthos:variativetext', 'adthos:templatefield'];
				var fixingAdthosTag = adthosTags.filter(f => rightPart.indexOf(`</${f}>`) > -1 && (rightPart.indexOf(`<${f}`) === -1 || rightPart.indexOf(`</${f}>`) < rightPart.indexOf(`<${f}`)))[0];
				if (fixingAdthosTag) {
					if (__DEBUG__)
						console.debug('Splitting before fixes', { leftPart, rightPart, fixingAdthosTag });
					leftPart += `${rightPart.split(`</${fixingAdthosTag}>`)[0]}</${fixingAdthosTag}>`;
					rightPart = rightPart.split(`</${fixingAdthosTag}>`).slice(1, 999999).join(`</${fixingAdthosTag}>`);
				}

				var joined = leftPart + '<SPLITTAG></SPLITTAG>' + rightPart;
				var joinedObj = $('<div>').append(joined);
				joinedObj.find('*').map((i, obj) => {
					var $obj = $(obj);
					$obj.contents().each((ci, c) => {
						if (c.nodeType === 3) {
							$(c).remove();
						}
					});
				})

				joinedObj.find('.highlighted').map((i, obj) => {
					var $obj = $(obj);
					if (!$obj.text().trim()) {
						if ($obj.find('splittag')[0]) {
							$obj.replaceWith('<splittag></splittag>');
						} else {
							$obj.remove();
						}
					}
				});

				joined = joinedObj.html();

				var removingTags = ['BREAK', 'break', ...adthosTags];
				var setTagsForRemoving = (text) => {
					if (!text) return text;
					removingTags.map(tag => {
						text = text
							.replace(new RegExp(`<${tag}`, 'g'), '<REMOVE')
							.replace(new RegExp(`${tag}>`, 'g'), 'REMOVE>');
					});
					return text;
				};

				var removeTags = (text) => {
					if (!text) return text;
					var item = $('<div>').append(text);
					item.find('REMOVE').remove();

					return item.html();
				};

				var splitTagFormattedParts = joined.split('<splittag></splittag>');
				var onlyTagsLeft = setTagsForRemoving(splitTagFormattedParts[0]) || '';
				var onlyTagsRight = setTagsForRemoving(splitTagFormattedParts[1]) || '';

				var finalLeftSSML = `${ssmlHelper.prepareSsml(ssmlHelper.replaceEmptyTags(removeTags(leftPart + onlyTagsRight)))?.ssml}`.trim();
				var finalRightSSML = `${ssmlHelper.prepareSsml(ssmlHelper.replaceEmptyTags(removeTags(onlyTagsLeft + rightPart)))?.ssml}`.trim();

				if (__DEBUG__)
					console.debug('Split ssml', { ssml: this.ssml, word, leftPart, rightPart, joined, finalLeftSSML, finalRightSSML, wordRepeats, onlyTagsRight, onlyTagsLeft, splitTagFormattedParts, splittedSSML, fixingAdthosTag, splittedTextArray: this.splittedTextArray, selectedIdx: this.selectedIdx });

				if (finalLeftSSML && finalRightSSML)
					this.$emit('split', [finalLeftSSML, finalRightSSML]);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ssml-insertion-splitter {
		.word {
			position: relative;
			padding: 14px 0px;
			cursor: pointer;

			.text {
				transition: 0.3s;
				padding: 4px 10px;
				margin: 4px;
				background: #e6e6e6;
				color: #333;
			}

			&:hover {
				.text {
					background: $base-accent-transparent;
				}
			}

			&.selected {
				.text {
					background: $base-accent;
					color: $base-bg;
				}
			}

			&:after {
				position: absolute;
				right: 0px;
				top: 50%;
				transform: translateY(-50%);
				content: '';
				height: 100%;
				width: 2px;
				background: transparent;
				transition: 0.3s;
				height: 0%;
			}

			&:hover, &.selected {
				&:after {
					background: $base-accent;
					height: 100%;
				}
			}
		}
	}
</style>
